import { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
export const AppLogo: FunctionComponent<
  React.PropsWithChildren<unknown>
> = () => {
  return (
    <Link style={{ textDecoration: 'none' }} to="/">
      <div
        data-testid="app-nav-logo"
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '2rem',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '2rem',
            height: '2rem',
          }}
        >
          <svg
            style={{
              width: '100%',
              height: '0.85rem',
              margin: 0,
            }}
            viewBox="0 0 64 32"
            fill="none"
          >
            <path
              fill="#5C49F4"
              d="M0 14.6939L30.8571 0V14.6939L0 29.3878V14.6939V14.6939ZM30.8572 29.3878L61.7143 14.6939V0L30.8572 14.6939V29.3878Z"
            />
          </svg>
        </div>
        <span
          style={{
            color: 'white',
            textAlign: 'center',
            height: '0.75rem',
            margin: 0,
            lineHeight: '0.75rem',
            fontWeight: '600',
            fontSize: '0.85rem',
            userSelect: 'none',
          }}
        >
          ml
        </span>
      </div>
    </Link>
  );
};
